import { useEffect, useRef } from "react";

export default function ErrorAlerts({
    duplicateProfile,
    npnNotFoundInPdb,
    feinNotFoundInPdb,
    producerNameMismatch,
    agencyNameMismatch,
    parentAgencyMustOnboard,
    agencyOffshoreMustBeApproved,
    setError
}) {
    const containerRef = useRef();

    useEffect(() => {
        if (feinNotFoundInPdb || agencyNameMismatch) {
            setError("agencyName", { type: "pdb", message: "Agency Name doesn't match FEIN records." });
        }
    }, [feinNotFoundInPdb, agencyNameMismatch]);

    useEffect(() => {
        if (npnNotFoundInPdb || producerNameMismatch) {
            setError("firstName", { type: "pdb", message: "First and Last Name must match NPN records." });
            setError("lastName", { type: "pdb", message: "First and Last Name must match NPN records." });
        }
    }, [npnNotFoundInPdb, producerNameMismatch]);

    useEffect(() => {
        if (parentAgencyMustOnboard) {
            setError("fein", {
                type: "parentAgencyMustOnboard",
                message: "Parent agency must complete application to continue."
            });
        }
    }, [parentAgencyMustOnboard]);

    useEffect(() => {
        if (agencyOffshoreMustBeApproved) {
            setError("fein", {
                type: "agencyOffshoreMustBeApproved",
                message: "Parent Agency must be approved for non-resident producers to continue."
            });
        }
    }, [agencyOffshoreMustBeApproved]);

    useEffect(() => {
        if (
            duplicateProfile ||
            npnNotFoundInPdb ||
            feinNotFoundInPdb ||
            producerNameMismatch ||
            agencyNameMismatch ||
            parentAgencyMustOnboard ||
            agencyOffshoreMustBeApproved
        ) {
            containerRef.current?.scrollIntoView?.({ behavior: 'smooth', block: 'start' });
        }
    }, [
        duplicateProfile,
        npnNotFoundInPdb,
        feinNotFoundInPdb,
        producerNameMismatch,
        agencyNameMismatch,
        parentAgencyMustOnboard,
        agencyOffshoreMustBeApproved
    ]);

    return <div ref={containerRef} className="container component-wrapper" style={{ scrollMarginTop: "6rem" }}>
        {
            duplicateProfile && <gds-alert>
                <gds-alert-message type="danger">
                    Duplicate profile detected{' '}
                    <span slot="content">
                        A profile with this information already exists.  If you need further assistance,
                        please contact our support team at 1-800-624-2513.
                    </span>
                </gds-alert-message>
            </gds-alert>
        }

        {
            (feinNotFoundInPdb || agencyNameMismatch) && <gds-alert>
                <gds-alert-message type="danger">
                    Agency Name Doesn't Match FEIN{' '}
                    <span slot="content">
                        The Agency Name you provided doesn't match the name associated with your Federal
                        Employer Identification Number (FEIN).
                    </span>
                </gds-alert-message>
            </gds-alert>
        }

        {
            (npnNotFoundInPdb || producerNameMismatch) && <gds-alert>
                <gds-alert-message type="danger">
                    Name Doesn't Match NPN{' '}
                    <span slot="content">
                        The First and/or Last Name you provided doesn't match the name
                        associated with your National Producer Number (NPN).
                    </span>
                </gds-alert-message>
            </gds-alert>
        }

        {
            parentAgencyMustOnboard && <gds-alert>
                <gds-alert-message type="danger">
                    Application Paused{' '}
                    <span slot="content">
                        Parent agency must complete application to continue. Our records indicate that
                        your parent agency has not completed their application.
                    </span>
                </gds-alert-message>
            </gds-alert>
        }

        {
            agencyOffshoreMustBeApproved && <gds-alert>
                <gds-alert-message type="danger">
                    Application Paused{' '}
                    <span slot="content">
                        Parent Agency must be approved for non-resident producers to continue.
                    </span>
                </gds-alert-message>
            </gds-alert>
        }
    </div>;
}